export default __webpack_public_path__ + "static/media/bootstrap.3b3ab2cf.svg";